/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 10/11/2024.
 */
/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/03/2023.
 */
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { post } from '../../service/API'
import { ENDPOINTS } from '../../service/ENDPOINTS'
import { HTTPMethod, VIEW_TYPE } from '../../Types'
import { useSWRConfig } from 'swr'
import { openNotification } from '../../components/notifications/openNotification'
import { Alert, Button, Popconfirm } from 'antd'

type Props = {
  closeDrawer?: (value) => void
  onClose?: () => void
  viewType?: VIEW_TYPE
}

export const QuestionnaireClone = ({ closeDrawer, onClose }: Props) => {
  const { projectId, groupId, protocolId, phaseId, questionnaireId } = useParams() as {
    projectId: string
    questionnaireId: string
    groupId: string
    phaseId: string
    protocolId: string
  }
  const { mutate: globalMutate } = useSWRConfig()

  const [errorState, setErrorState] = useState<any>()

  const onSubmit = () => {
    const sendData = { groupId: groupId, phaseId: phaseId, questionnaireId: questionnaireId }

    return post(ENDPOINTS.QUESTIONNAIRES.ACTIONS.clone(projectId), sendData, HTTPMethod.POST)
      .then((result) => {
        openNotification('Questionnaire cloned', '', 'happy')

        globalMutate(ENDPOINTS.QUESTIONNAIRES.byQuestionnaireId(projectId, questionnaireId))
        globalMutate(ENDPOINTS.PROTOCOLS.GET_ONE(projectId, protocolId))

        if (onClose) {
          onClose()
        }
        if (closeDrawer) {
          closeDrawer(false)
        }
      })
      .catch((error) => {
        console.log('error = ', error)
        setErrorState(error)
      })
  }

  const navigateBack = () => {
    console.log('navigateBack', onClose)
    if (onClose) {
      onClose()
    }
  }

  return (
    <>
      <div>
        <div className="">
          <p>Here you are able to clone the questionnaire</p>
        </div>
        <div className="col-12 mt-3 d-flex justify-content-end">
          <Button className="me-2" type="default" onClick={navigateBack}>
            Cancel
          </Button>

          <Popconfirm
            placement="left"
            title={<p className="pe-4">Please confirm your action</p>}
            description={<p className="pe-4">Do you want to continue cloning this questionnaire</p>}
            onConfirm={onSubmit}
            //onCancel={}
            okText={<p className="px-2">Yes</p>}
            cancelText="No"
          >
            <Button type="primary">Clone</Button>
          </Popconfirm>
        </div>
      </div>
      <div className="col-12 mt-3">
        {errorState ? (
          <Alert showIcon message={errorState.type} description={errorState.message} type="error" />
        ) : (
          <></>
        )}
      </div>
    </>
  )
}
